const en = {
  common: {
    searchPlaceholder: 'Please enter yyyy-mm to search.',
    search: 'Search',
    reset: 'Reset',
    noData: 'No data available.',
    player: 'Player',
    centre: 'Centre',
    enterDeleteReason: 'Please enter a reason for deletion.',
    confirmDelete: 'Do you want to delete {{target}}?',
    delete: 'Delete',
    cancel: 'Cancel',
    loginId: 'Login ID',
    representativeName: 'Representative Name',
    registeredDate: 'Registered Date',
    country: 'Country',
    mobileNumber: 'Mobile Number',
    firstName: 'First Name',
    lastName: 'Last Name',
    dateOfBirth: 'Date of Birth',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    nationality: 'Nationality',
    subscriberName: 'Subscriber Name',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    postcode: 'Postcode',
    address: 'Address',
    selectFile: 'Select File',
    serverConnectionFailed:
      'Failed to connect to the server.\nPlease try again later.',
    previous: 'Previous',
    next: 'Next',
    failConnect: 'Failed to connect to the server.\nPlease try again later.',
  },
  navbar: {
    playerList: 'Player List',
    partnerList: 'Partner List',
    r2CenterList: 'R2 Centre List',
    r2PlannerList: 'R2 Planner List',
    signUp: 'Sign Up',
    playerSignUp: 'Player Sign Up',
    centreSignUp: 'Centre Sign Up',
    r2LicenseKeyManagement: 'R2 Licence Key Management',
    logout: 'Log Out',
  },
  playerList: {
    title: 'Player List',
    officeName: 'Office Name',
    office: 'Office (Dental Clinic)',
    contact: 'Contact',
  },
  playerDetail: {
    clinicNumber: 'Clinic Number',
    officeName: 'Office Name',
    officeAddress: 'Office Address',
  },
  deleteAccount: {
    deleteAccount: 'Delete Account',
    notFound: 'The requested item could not be found.',
    hasCloudOrderData: 'Cloud-related order data exists.',
    hasScannerData: 'Scanner-related data exists.',
    hasChatData: 'Chat data exists.',
    hasPingPongOrderData: 'PingPong order data exists.',
    deleteSuccess: 'The account has been successfully deleted.',
    deleteFailed: 'An error occurred while deleting the account.',
    hasPartnerServiceData: 'Partner service data exists.',
    hasFavouritePlayers: 'Some players have this partner in their favourites.',
    hasPartnerProfileData: 'Partner profile data exists.',
  },
  centerList: {
    title: 'R2 Centre List',
    centerName: 'Centre Name',
    centerNumber: 'Centre Number',
    centerAddress: 'Centre Address',
    businessDocument: 'Business Document',
  },
  plannerList: {
    title: 'R2 Planner List',
    plannerName: 'R2 Planner Name',
    phoneNumber: 'Phone Number',
    qualificationDocument: 'Qualification Document',
  },
  signUp: {
    title: 'New Member Registration',
    description:
      'Administrators can create and manage new {{type}} accounts directly.',
    notice:
      'Please use the account holder’s actual information. Providing false information may result in restrictions on the use of the service.',
    accountActivation: 'Account Activation',
    permission: 'Permissions',
    submit: 'Register',
    passwordRule:
      'Password must be at least 8 characters and include letters, numbers and special characters.',
    passwordMismatch: 'Passwords do not match.',
    emailAlreadyExists: 'This email address is already in use.',
    registrationReason: 'Registration Reason',
    registrationReasonPlaceholder:
      'e.g. Created via the admin portal following a KakaoTalk request from 000.',
    numberOnly: 'Numbers only',
  },
  playerSignUp: {
    registerSuccess: 'A new Player account has been created for {{name}}.',
    contactAndAffiliation: 'Contact & Affiliation',
    officeName: 'Office Name',
    officeNamePlaceholder: 'Enter office name',

    createPlayerAccount: 'Create Player Account',

    loginInformation: 'Login Information',
    email: 'Email',
    password: 'Password',
    passwordPlaceholder:
      'At least 8 characters with letters, numbers and special characters',
    confirmPassword: 'Confirm Password',
    confirmPasswordPlaceholder: 'Re-enter password',

    basicInformation: 'Basic Information',

    firstNamePlaceholder: 'Smith',
    lastNamePlaceholder: 'John',

    selectNationality: 'Select nationality',
    detailAddressPlaceholder: 'Enter detailed address',
    clinicNumber: 'Clinic Number',
    centerAddress: 'Centre Address',
    officeAddress: 'Office Address',
  },
  centerSignUp: {
    businessDocumentRequired: 'A business document is required.',
    registerSuccess: 'A new Centre account has been created for {{name}}.',
    maxFileCount: 'You can upload up to 5 files.',
    supportedFileTypes: 'Only JPG, JPEG, PNG and PDF files are supported.',
    maxFileSize: 'Each file must not exceed 40 MB.',
    fileUploadFailed: 'An error occurred while uploading the file.',
    contactAndCenterInformation: 'Contact & Centre Information',
    representativeNamePlaceholder: 'Enter representative name',
    businessDocument: 'Business Document',
    createCenterAccount: 'Create Centre Account',
    r2CenterName: 'R2 Centre Name',
    centerNamePlaceholder: 'Enter centre name',
    r2CenterPhoneNumber: 'R2 Centre Phone Number',
  },
  licenseManagement: {
    title: 'R2 Licence Key Management',
    issueAll: 'Issue All',
    totalIssuedLicenseKeys: 'Total Issued Licence Keys',
    status: {
      unregistered: 'Unregistered',
      pending: 'Pending',
      registered: 'Registered',
      activated: 'Activated',
      revoked: 'Revoked',
      unavailable: 'Unavailable',
    },
    number: 'No.',
    licenseKey: 'Licence Key',
    moduleName: 'Module Name',
    statusLabel: 'Status',
    createdDate: 'Created Date',
    registeredDate: 'Registered Date',
    revokedDate: 'Revoked Date',
    registeredId: 'Registered ID',
    issuer: 'Issuer',
    issueReason: 'Issue Reason',
    memo: 'memo',
    issueLicenseKey: 'Issue Licence Key',
    enableRevocationMode: 'Enable Revocation Mode',
    disableRevocationMode: 'Exit Revocation Mode',

    issueForm: {
      issuer: 'Issuer',
      issueReason: 'Issue Reason (Max 30 characters)',
      moduleType: 'Module Type',
      issueQuantity: 'Issue Quantity (Max 10)',
      issue: 'Issue',
    },

    copyLicenseKey: 'Copy Licence Key',
    close: 'Close',
    memoCell: {
      addMemo: 'Add memo',
      writtenBy: 'Memo written by:',
      lockedNotice: "A memo can't be edited once registered.",
      close: 'Close',
      placeholder: 'Enter a memo',
      writeNotice:
        "Memos can't be edited after registration<br/>please write carefully.",
      cancel: 'Cancel',
      register: 'Register',
    },
    messages: {
      moduleChangeWarning:
        'Changing the module will reset the issued licence key information.\nIssued licence key information can be viewed in the list.\n\nWould you like to change the module?',
      issueReasonRequired: 'Please enter an issue reason.',
      issueQuantityRequired: 'Please enter the issue quantity.',
      issueQuantityLimit: 'A maximum of 10 keys can be issued at once.',
      copySuccess: 'Licence key copied.',
      exitIssueConfirm: 'Would you like to exit licence key issuance?',
      issuing: 'Issuing...',
      issue: 'Issue',
      revokeConfirm:
        'Would you like to revoke the registered licence key?\nThe revoked licence key cannot be used again.\n\nModule: {{module}}\nLicence Key: {{licenseKeyId}}\nRegistered ID: {{usedByMemberLoginId}}',
      revokeSuccess: 'Licence key has been revoked.',
      cannotRevoke: 'This licence key cannot be revoked.',
      licenceKeyNotFound:
        "This licence key doesn't exist. Please refresh the list and try again.",
      memoAlreadyRegistered:
        "A memo is already registered for this key and can't be edited.",
      memoRequired: 'Please enter a memo and try again.',
    },
  },
} as const;

export default en;
